module.exports = __webpack_public_path__ + "img/category-sport-hover.225d6e86.png";